module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "tlHeader",
    style: (_vm.getStyle)
  }, [_c('span', {
    staticClass: "tlHeaderText"
  }, [_vm._v(_vm._s(_vm.classroom))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4622845c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/timetable/SpClassroomHeader.vue
// module id = 697
// module chunks = 0